import React from "react";
import { Loader } from "lucide-react";
import "./FullPageSpinner.css"; // Ensure you create a CSS file for styling

const FullPageSpinner = ({ loading, message }) => {
  if (!loading) return null;

  return (
    <div className="spinner-overlay">
      <div className="spinner-container">
        <Loader className="spinner-icon" size={50} />
        {message && <p className="spinner-message">{message}</p>}
      </div>
    </div>
  );
};

export default FullPageSpinner;
